import axios from 'axios'
// import { Message } from 'element-ui'
import {TokenUtil} from "@/utils/comm";
import {closeToast, showLoadingToast, showToast} from 'vant';
import 'vant/es/toast/style';
import {encryptQuery} from "./filter";

axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";

// create an axios instance
const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 500000 // request timeout
})

// request interceptor
service.interceptors.request.use(async config => {
        showLoadingToast('加载中...');
        //请求接口添加token
        config.headers.Authorization = TokenUtil.getAccessToken();
        // 参数加密
        encryptQuery(config)

        if (config.intercept) return config;

        return config;
    },
    error => {
        return Promise.reject(error)
    }
);

// response interceptor
service.interceptors.response.use(

    res => {
        closeToast();
        if (res.status === 200 && (res.data.code == 100 || res.data.code == 200 || res.data.code == 0 || !!res.data.access_token)) {
            return Promise.resolve(res.data);
        } else if (res.status == 200) {
            return Promise.resolve(res.data);
        } else {
            onError(res.data);
            return Promise.resolve(res);
        }
    },
    error => {
        closeToast();
        if (error.response && error.response.data) {
            return Promise.reject(error.response.data);
        } else {
            onError(error);
            return Promise.reject(error);
        }
    }
);

//get请求
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        service.get(url, {params: params}).then(res => {
            if (res) resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}

//post请求
export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
        service.post(url, params).then(res => {
            if (res) resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}

//自定义接口请求
export const sendReq = async (option) => {
    const defaultOption = {
        method: "GET",
        intercept: true
    }
    const res = await service.request(
        Object.assign(defaultOption, option)
    );
    return res;
}
export const sendReqH5 = async (option) => {
    if (!option.headers.Authorization) {
        option.headers.Authorization = 'Bearer ' + TokenUtil.getToken()
    }
    const res = await service.request(option).catch(err => {
        showToast.fail({message: '请求出错了'})
    })
    return res
}

export const lowCodePost = async (url, params) => {
    const defaultOption = {
        method: 'POST',
        intercept: true,
        url: url,
        data: params,
        headers: {'content-type': 'application/json'}
    }
    const res = await service.request(defaultOption)
    return res
}

//自定义请求头get请求
export function ownGet(url, params = {}) {
  return new Promise((resolve, reject) => {
      axios.get(url, {params: params}, {headers: {'content-type': 'application/x-www-form-urlencoded'}})
          .then(res => {
              if (res) resolve(res.data);
          })
          .catch(err => {
              reject(err);
          });
  });
}

//post请求
export function ownPost(url, params = {}) {
  const temParams = new URLSearchParams();
  for(let item in params){
      temParams.append(item, params[item]);
  }
  return new Promise((resolve, reject) => {
      axios
          .post(url, temParams, {headers: {'content-type': 'application/x-www-form-urlencoded'}})
          .then(res => {
              if (res) resolve(res.data);
          })
          .catch(err => {
              reject(err);
          });
  });
}

let showError = throttle((msg, cb) => {
    // Message.error(msg);
    showToast(msg);
    if (typeof cb === "function") cb();
});

//接口报错处理
function onError(res) {
    if (res.code) {
        switch (res.code) {
            //用户登录过期
            case 401:
                showError("用户登录过期，请重新登录！", () => {
                    // SysUtil.clearSysState();
                });
                break;
        }
    }
}

function throttle(cb) {
    var timer = null;
    return function () {
        var context = this,
            args = arguments;
        if (!timer) {
            cb.apply(context, args);
            timer = setTimeout(() => {
                clearTimeout(timer);
                timer = null;
            }, 2000);
        }
    };
}


export default service
